@import 'vars';
@import 'mixins';

$width: 500px;
$padding: 20px;

.drawer {
  width: $width;
  max-width: 90%;
  height: 100vh;

  position: absolute;
  right: 0;

  background-color: white;
  border: 1px solid $mid-grey;

  display: flex;
  flex-direction: column;
  padding: $padding;
  gap: $padding;

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: $padding;

    &:global {
      > .header2 {
        flex-grow: 1;
      }
    }

    &__body {
      display: flex;
      flex: 1;

      &__title {
        margin-right: auto;
      }
    }
  }

  &__content {
    @include scrollable-container;

    display: flex;
    flex: 1;
  }
}
